<form #form="ngForm">
    <p style="text-align: left">{{ 'settings.billing.cancelSubscriptionFormMessage' | appTranslate }}</p>
    <div class="app-grid">
        <mat-form-field>
            <mat-label appRemoveAriaOwns>{{ 'settings.billing.cancelReasonLabel' | appTranslate }}</mat-label>
            <mat-select name="reason" [(ngModel)]="reason" required>
                <mat-option *ngFor="let reason of reasons" [value]="reason">{{ reason | appTranslate }}</mat-option>
            </mat-select>
        </mat-form-field>
        <ng-container *ngIf="reason === 'settings.billing.cancelReasons.other'">
            <mat-form-field>
                <mat-label>{{ 'settings.billing.tellUsWhyLabel' | appTranslate }}</mat-label>
                <textarea name="note" height="200px" [(ngModel)]="note" required matInput></textarea>
            </mat-form-field>
        </ng-container>
        <ng-container *ngIf="reason !== 'settings.billing.cancelReasons.other'">
            <mat-form-field>
                <mat-label>{{ 'settings.billing.anythingElseLabel' | appTranslate }}</mat-label>
                <textarea name="note" height="200px" [(ngModel)]="note" required matInput></textarea>
            </mat-form-field>
        </ng-container>
    </div>
</form>
